module.exports = __webpack_public_path__ + "img/ennetix-solution.46922bb3.png";